import React from 'react'
import Slider from 'react-slick'
import { Box, Typography } from '@mui/material'
import { NextArrow, PrevArrow } from './carouselArrows'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './reviewCarousel.css'

const predefinedComments = [
  {
    name: 'Sally',
    text:
      'Charlie and his team have completed work for us a couple of times and both times we have been extremely pleased with the outcome.',
  },
  {
    name: 'Graham',
    text:
      'I have used Charlie to cut my grass and trim my bushes for over five years and found him to be reliable and efficient.',
  },
  {
    name: 'Jane',
    text:
      "Just had my large patio area done by Read Landscaping. Charlie and Co never let me down with their punctuality. 5 Star all the way.",
  },
  {
    name: 'Ben',
    text:
      'Charlie and his team created a patio and border beds in my garden. They did a fantastic job.',
  },
]

const ReviewCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  }

  return (
    <Box className="review-container" sx={{ width: { xs: '90%' }, mx: 'auto' }}>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          color: '#f5f7f6',
          textAlign: 'center'
        }}
      >
        Client Testimonials
      </Typography>

      <Typography className="review-subtitle" sx={{ my: 2 }}>
        We take pride in delivering exceptional results and outstanding customer service. Here’s what our clients have to say—read more of our 5-star reviews on Google.
      </Typography>

      {/* THIS WRAPPER IS THE KEY */}
      <Box className="review-carousel-inner">
        <Slider {...settings}>
          {predefinedComments.map((comment, index) => (
            <Box key={index} className="review-slide">
              <Box className="review-card">
                <Typography className="review-name">
                  {comment.name}
                </Typography>

                <Typography className="review-text">
                  “{comment.text}”
                </Typography>
              </Box>
            </Box>
          ))}
        </Slider>
      </Box>
    </Box>
  )
}

export default ReviewCarousel
